import { getValidationSchema } from "@Shared/utils/validationSchema";
import * as yup from "yup";
import logPrinterFormMeta, { ILogPrinterFormMeta } from "./LogPrinterFormMeta";
import receiptPrinterFormMeta, { IReceiptPrinterFormMeta } from "./ReceiptPrinterFormMeta";
import statementPrinterFormMeta, { IStatementPrinterFormMeta } from "./StatementPrinterFormMeta";

export interface IPrintersFormMeta extends ILogPrinterFormMeta, IReceiptPrinterFormMeta, IStatementPrinterFormMeta {
  
  schema: any;
}

let printersFormMeta = {} as IPrintersFormMeta;

printersFormMeta = {
    ...printersFormMeta, ...logPrinterFormMeta, ...receiptPrinterFormMeta, ...statementPrinterFormMeta
};

printersFormMeta.schema = yup.object().shape(getValidationSchema(printersFormMeta));

export default printersFormMeta;